import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

const NavbarDropdown = ({ title, items }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div 
      className="relative"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <button
        className="flex items-center gap-1 text-base font-normal text-gray-400 hover:text-white transition-colors py-2"
      >
        {title}
        <ChevronDown 
          size={16} 
          className={`transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-2 w-[400px] bg-black/95 backdrop-blur-md border border-white/10 rounded-2xl shadow-2xl py-3 z-50">
          {items.map((item, index) => (
            <Link
              key={index}
              to={item.path}
              className="block px-6 py-3 text-sm text-gray-300 hover:text-white hover:bg-white/5 transition-all duration-200 whitespace-nowrap"
            >
              {item.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default NavbarDropdown;
